import { FC } from 'react';
import { styled } from '@mui/material';
import { ZIndexes } from 'enums/z-indexes';
import { useTranslation } from 'react-i18next';
import { SCREEN_SIZE_BORDER } from 'constants/frontend-contsants';

import Grid from '@mui/material/Grid';
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Backdrop from '@mui/material/Backdrop';
import MenuItem from '@mui/material/MenuItem';
import useWindowDimensions from 'hooks/use-window-dimensions';
import { colors } from 'constants/colors';

const StyledCornerButton = styled(Button)({
  color:colors.default.secondary,
  flex: '1 1',
  padding: '20px',
  fontSize: '16px',
  lineHeight: '22px',
  textTransform: 'none',
  fontFamily: 'Avenir',
  background: '#E2E3E4 !important',
});

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.error.main,
  flex: '1 1',
  padding: '20px',
  fontSize: '16px',
  lineHeight: '22px',
  textTransform: 'none',
  fontFamily: 'Avenir',
  marginTop: '8px',
}));

const StyledMenuItem = styled(MenuItem)({
  display: 'flex',
  justifyContent: 'center',
  padding: '15px 0',
  fontWeight: 500,
  fontFamily: 'Avenir-Regular',
  color: colors.default.secondary,
  borderRadius: '27px',
  '&:hover': {
    background: '#ACFB68',
  },
});

const StyledMenu = styled(Menu)({
  '& .MuiPaper-root': {
    borderRadius: '27px',
    width: '380px',
  },
  '& .MuiList-root': {
    background: '#FFF',
    borderRadius: '27px',
  },
});

interface ProfileMenuProps {
  opened: boolean;
  anchor?: null | HTMLElement;
  onClose: () => any;
  onShare: () => any;
  onUnsubscribe: () => any;
}

const ProfileMenu: FC<ProfileMenuProps> = ({
  anchor,
  opened,
  onClose,
  onShare,
  onUnsubscribe,
}) => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  return (
    <>
      {width > SCREEN_SIZE_BORDER && (
        <StyledMenu
          open={Boolean(anchor)}
          anchorEl={anchor}
          onClose={onClose}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <StyledMenuItem onClick={onShare}>
            {t('buttons.share')}
          </StyledMenuItem>
          <Divider sx={{ borderBottom: '0.5px solid #9F9F9F' }} />
          <StyledMenuItem onClick={onUnsubscribe}>
            {t('buttons.unsubscribe')}
          </StyledMenuItem>
        </StyledMenu>
      )}
      {width < 900 && (
        <Backdrop
          open={opened}
          style={{
            zIndex: ZIndexes.External_Modal_First,
            alignItems: 'flex-end',
          }}
        >
          <Grid
            display="flex"
            padding="33px 8px"
            width="100%"
            flexDirection="column"
          >
            <StyledCornerButton
              variant="contained"
              color="info"
              sx={{ borderRadius: '30px 30px 0 0' }}
              onClick={onShare}
            >
              {t('buttons.share')}
            </StyledCornerButton>
            <StyledCornerButton
              variant="contained"
              color="info"
              sx={{ borderRadius: '0 0 30px 30px' }}
              onClick={onUnsubscribe}
            >
              {t('buttons.unsubscribe')}
            </StyledCornerButton>

            <StyledButton variant="contained" color="info" onClick={onClose}>
              {t('buttons.cancel')}
            </StyledButton>
          </Grid>
        </Backdrop>
      )}
    </>
  );
};

export default ProfileMenu;
